"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function OurVisionValues() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const values = ["Innovation", "Integrity", "Impact"];
  return <section id="our-vision-values" ref={ref} className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32 flex flex-col items-center justify-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <span className="text-[10rem] md:text-[18rem] font-black tracking-tighter text-transparent opacity-10 whitespace-nowrap" style={{
        WebkitTextStroke: "2px var(--color-muted-foreground)"
      }}>
          INARA
        </span>
      </div>

      {}
      <div className={cn("relative z-10 container mx-auto px-6 flex flex-col items-center text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        {}
        <h2 className="text-2xl md:text-4xl font-serif text-white leading-relaxed max-w-4xl mx-auto mb-16 drop-shadow-lg">
          Harnessing AI and Cloud Computing for Sustainable Growth in Kenya and East Africa
        </h2>

        {}
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16">
          {values.map((value, i) => <div key={value} data-index={i} className="flex items-center gap-3 group">
              {}
              <span className="w-2 h-2 rounded-full bg-chart-2 shadow-[0_0_12px_var(--color-chart-2)] group-hover:scale-150 transition-transform duration-300" />
              
              {}
              <span className="text-lg tracking-widest uppercase text-muted-foreground font-medium group-hover:text-primary transition-colors duration-300">
                {value}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}